// -----------------------------------------------------------------------------
// Scripts for speakers sliders
// -----------------------------------------------------------------------------

$(function () {
  const speakers = $('.section-speakers');

  $.each(speakers, function(index, value) {
    const speakerSlider = $(this).find('[data-speakers-slider]').attr('id');
    const speakerSliderAutoplay = $(this).find('[data-speakers-slider]').attr('data-slider-autoplay');
    let clickSpeakerSlideActive = true;
  
    $(`#${speakerSlider}`).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: speakerSliderAutoplay === 'true' ? true : false,
      infinite: speakerSliderAutoplay === 'true' ? true : false,
      dots: false,
      arrows: false,
      variableWidth: true,
      touchThreshold: 50
    });

    $(`#${speakerSlider}`).on('beforeChange', function(slick, currentSlide, nextSlide){
      clickSpeakerSlideActive = false;
    });

    $(`#${speakerSlider}`).on('afterChange', function(slick, currentSlide){    
      clickSpeakerSlideActive = true;
    });

    $(`#${speakerSlider}`).on('swipe', function(event, slick, direction){
      clickSpeakerSlideActive = false;
    });
    
    $('[data-speakers-slide]').on('click', function(){
      const modalBody = $('#speakerModal').find('[data-modal-body]');
      const personId = $(this).attr('data-speaker-item');
      const modalContent = $(`#${personId}`).html();
      const modal = new bootstrap.Modal(document.getElementById('speakerModal'));

      if(clickSpeakerSlideActive) {
        modalBody.html(modalContent);
        modal.toggle();
      }
    });
  });
});